import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PersonModel } from '../models/person/person.model';
import { AuthenticatedPersonModel } from '../models/person/authenticated-person.model';

@Injectable({
  providedIn: 'root'
})
export class UserContextService {
  private roleSubject = new BehaviorSubject<string | null>(null);
  role$ = this.roleSubject.asObservable();

  private currentPersonSubject = new BehaviorSubject<AuthenticatedPersonModel | null>(null);
  currentPerson$ = this.currentPersonSubject.asObservable();

  readonly managerRole: string = 'Manager';
  readonly brokerRole: string = 'Broker';
  readonly trainerRole: string = 'Trainer';
  readonly superAdminRole: string = 'SuperAdmin';

  setRole(role: string) {
    this.roleSubject.next(role);
  }

  get currentRole(): string | null {
    return this.roleSubject.value;
  }

  get isManager(): boolean {
    return this.currentRole == this.managerRole;
  }

  get isBroker(): boolean {
    return this.currentRole == this.brokerRole;
  }

  get isTrainer(): boolean {
    return this.currentRole == this.trainerRole;
  }

  get isSuperAdmin(): boolean {
    return this.currentRole == this.superAdminRole;
  }

  setCurrentPerson(person: AuthenticatedPersonModel) {
    this.currentPersonSubject.next(person);
  }

  get currentPerson(): AuthenticatedPersonModel | null {
    return this.currentPersonSubject.value;
  }

  get canUseTextTemplates(): boolean {
    return this.isSuperAdmin || this.isTrainer;
  }

  get currentPersonCulture(): string | null {
    return this.currentPerson?.person.culture ?? null;
  }
}
